import { Button, ConfigProvider } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { ERP_THEME_VALUES } from '../styles/antd-theme-values.js';
import styles from './cancel-button.module.scss';

const { colors } = ERP_THEME_VALUES;

const cancelButtonTheme = {
  components: {
    Button: {
      defaultBg: '#ccc',
      defaultBorderColor: '#ccc',
      defaultColor: '#000',
      defaultHoverBg: colors.error,
      defaultHoverBorderColor: colors.error,
      defaultHoverColor: '#fff',
      defaultActiveBg: colors.error,
      defaultActiveBorderColor: colors.error,
      defaultActiveColor: '#fff',
    },
  },
};

const CancelButton = ({ children, className, color = 'default', variant = 'outlined', ...buttonProps }) => (
  <ConfigProvider theme={cancelButtonTheme}>
    <Button
      className={[styles.cancelButton, className].filter(Boolean).join(' ')}
      color={color}
      variant={variant}
      {...buttonProps}
    >
      {children}
    </Button>
  </ConfigProvider>
);

CancelButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  variant: PropTypes.string,
};

export default CancelButton;
